import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import RightsCheck from "../General/RightsCheck";
import { scrollToTop } from "../Shared/ScrollOnTop";

function StudentMenu(props) {
  return (
    <>
      <RightsCheck />
      <nav className="navbar navbar-expand-lg navbar-module MenuSticky">
        <div className="container-fluid">
        <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#NavbarSecondary"
            aria-controls="NavbarSecondary"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse"  id="NavbarSecondary">
            <ul className="navbar-nav m-auto">
              <li className="nav-item">
                <NavLink onClick={scrollToTop} to="/students/AddStudent">
                  <span className="nav-link"> Add Student</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={scrollToTop} to="/students/AdmitStudent">
                  <span className="nav-link">Admit Student </span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={scrollToTop} to="/students/NewStudentList">
                  <span className="nav-link">New Student List </span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/students/SearchStudents"
                >
                  {" "}
                  Search Student
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/students/AdvanceSearch"
                >
                  {" "}
                  Advance Search
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/students/ChangeRegistrationNo"
                >
                  Change Reg No
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/students/QuickSearchStudents"
                >
                  Quick Search
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/students/StudentPaymentReport"
                >
                  Payment report
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/students/BiodataLists"
                >
                  Biodata Lists
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/student/StudentProfileSearch"
                >
                  Student Profile
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default StudentMenu;
